import { SearchOutlined } from "@ant-design/icons";
import { Input, Select } from "antd";

interface ClientsFiltersProps {
	searchQuery: string;
	setSearchQuery: (val: string) => void;
	selectedBuilding: string;
	setSelectedBuilding: (val: string) => void;
	selectedManager: string;
	setSelectedManager: (val: string) => void;
	selectedStatus: string;
	setSelectedStatus: (val: string) => void;
	buildingOptions: string[];
	managerOptions: string[];
	statusOptions: string[];
}

export function ClientsFilters({
	searchQuery,
	setSearchQuery,
	selectedBuilding,
	setSelectedBuilding,
	selectedManager,
	setSelectedManager,
	selectedStatus,
	setSelectedStatus,
	buildingOptions,
	managerOptions,
	statusOptions,
}: ClientsFiltersProps) {
	return (
		<div className="crm-card crm-org-filters" style={{ marginBottom: "16px" }}>
			<div
				className="crm-card-body"
				style={{
					display: "flex",
					gap: "10px",
					flexWrap: "wrap",
					alignItems: "center",
				}}
			>
				<Input
					className="crm-filter-search grow"
					style={{ maxWidth: "280px" }}
					prefix={<SearchOutlined />}
					placeholder="Ism yoki telefon"
					value={searchQuery}
					onChange={(e) => setSearchQuery(e.target.value)}
				/>
				<Select
					style={{ width: "160px" }}
					value={selectedBuilding}
					onChange={setSelectedBuilding}
					options={buildingOptions.map((item) => ({
						label: item,
						value: item,
					}))}
				/>
				<Select
					style={{ width: "170px" }}
					value={selectedManager}
					onChange={setSelectedManager}
					options={managerOptions.map((item) => ({
						label: item,
						value: item,
					}))}
				/>
				<Select
					style={{ width: "180px" }}
					value={selectedStatus}
					onChange={setSelectedStatus}
					options={statusOptions.map((item) => ({
						label: item,
						value: item,
					}))}
				/>
			</div>
		</div>
	);
}
